import { APP_CONFIG } from '@/config';
import { tokenStorage } from '@/features/auth/utils/tokenStorage';

let refreshInFlight: Promise<void> | null = null;

export async function ensureAccessTokenFresh(): Promise<void> {
  const access = tokenStorage.getAccessTokenOptional();
  if (!access || access.endsWith('.mock_signature')) return;

  const refreshToken = tokenStorage.getRefreshTokenOptional();
  if (!refreshToken) return;

  const expiresAt = tokenStorage.getAccessExpiresAtOptional();
  if (!expiresAt) return;

  const leewayMs = APP_CONFIG.session.accessTokenRefreshLeewayMs;
  const msUntilExpiry = expiresAt - Date.now();
  if (msUntilExpiry > leewayMs) return;

  if (!refreshInFlight) {
    refreshInFlight = (async () => {
      const { authService } = await import('@/features/auth/services/authService');
      await authService.refresh();
    })().finally(() => {
      refreshInFlight = null;
    });
  }

  await refreshInFlight;
}
